// Styles
import styles from './BannerImage.module.css';

/**
 * @function BannerImage
 * Banner image describing current promotion
 *
 * @example
 * return (
 *   <BannerImage title=" image="" url="" />
 * )
 */
function BannerImage({ title, image, url }: BannerImageProps): JSX.Element {
    return (
        <picture className={styles.picture}>
            <a
                href={url}
                target="_blank"
                rel="noreferrer"
                className={styles.link}
            >
                {/*
          <source
            media="(max-width: 767px)"
            srcSet={image.replace('.png', '-s.png')}
          />
          <source media="(min-width: 768px)" srcSet={image} />
        */}
                <img src={image} alt={title} />
            </a>
        </picture>
    );
}

/**
 * @interface BannerImageProps
 * Describes the properties required for the BannerImage component
 *
 * @property {string} title
 * @property {string} image
 * @property {string} url
 */
export interface BannerImageProps {
    title: string;
    image: string;
    url: string;
}

// Exports
export default BannerImage;
